import { render } from "./EngineTabBar.vue?vue&type=template&id=4b03631c&scoped=true"
import script from "./EngineTabBar.vue?vue&type=script&lang=js"
export * from "./EngineTabBar.vue?vue&type=script&lang=js"

import "./EngineTabBar.vue?vue&type=style&index=0&id=4b03631c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b03631c"]])

export default __exports__